import { createSlice } from "@reduxjs/toolkit";

// export const draftSlice = createSlice({
//   name: "drafts",
//   initialState: {
//     drafts: [],
//     draftCount: 0,
//   },
//   reducers: {
//     addDraft: (state, action) => {
//       state.drafts.push({
//         id: state.drafts.length + 1,
//         title: `${action.payload.title}`,
//       });
//       state.draftCount += 1;
//     },
//   },
// });

export const draftSlice = createSlice({
  name: "drafts",
  initialState: {
    drafts: JSON.parse(localStorage.getItem("drafts_list")) || [],
    draftCount: JSON.parse(localStorage.getItem("drafts_list"))
      ? JSON.parse(localStorage.getItem("drafts_list")).length
      : 0,
  },
  reducers: {
    addDraft: (state, action) => {
      const newDraft = {
        id: state.draftCount + 1,
        userId: action.payload.userId,
        title: action.payload.title,
        content: action.payload.content,
      };
      state.drafts.push(newDraft);
      state.draftCount += 1;
      localStorage.setItem("drafts_list", JSON.stringify(state.drafts));
    },
    deleteDraft: (state, action) => {
      const draftId = action.payload;
      const filteredDrafts = state.drafts.filter(
        (draft) => draft.id !== draftId
      );
      state.drafts = filteredDrafts;
      state.draftCount = filteredDrafts.length;
      localStorage.setItem("drafts_list", JSON.stringify(filteredDrafts));
    },
  },
});

export const { addDraft, deleteDraft } = draftSlice.actions;

export default draftSlice.reducer;
